import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { previewPdf } from "../../../shared/FileDownload";
import { printGridService } from "services/claims.service";
export default function CustomPrintButton(props) {
  const { page, pageSize, searchArrayUpdate, actionRef } = props;
  const [isLoader, setLoader] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: page,
    pageSize: pageSize,
  });
  const printDiaryPdf = () => {
    let body = {
      pagination: searchArrayUpdate[0].value === "TRUE" ? pagination : pagination,
      search: searchArrayUpdate,
      sort: {
        columnName: "checkDate",
        orderBy: "ASC",
      },
    };
    setLoader(true);
    printGridService(body).then((result) => {
      setLoader(false);
      if (result && result.status === 200) {
        previewPdf(result.data);
      } else {
      }
    });
  };

  const handleSubmit = () => {
    printDiaryPdf();
  };

  return (
    <div className="custom-print__button">
      <Button
        variant="outlined"
        color="primary"
        onClick={handleSubmit}
        className="button-custom"
        disabled={isLoader}
        ref={actionRef}
      >
        {!isLoader ? "Print Grid" : "Printing..."}
      </Button>
    </div>
  );
}
